import React, { useContext } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { DraggableSheet } from './DraggableSheet';
import { RoundButton } from 'components/RoundButton';
import { DimensionsContext } from 'context/DimensionsContext';

const routeImage = require('assets/navigation.svg');

type Props = {
  close: Function;
  testID: string;
  title?: string;
  children?: React.JSX.Element | React.JSX.Element[];
  addDestination?: Function;
  id: string;
  open: boolean;
};

export function PopupMenu({
  close,
  testID,
  title,
  children,
  addDestination,
  id,
  open,
}: Props) {
  const dimensions = useContext(DimensionsContext);
  const style = dimensions.size === 'large' ? desktopStyles : styles;

  return (
    <DraggableSheet dismiss={close} testID={testID} open={open} id={id}>
      <View style={styles.container}>
        <Text testID={`${testID}_title`} style={styles.title}>
          {title}
        </Text>
        <View style={styles.childContainer}>{children}</View>

        {addDestination && (
          <Pressable testID={`${testID}_directions`} style={style.button}>
            <RoundButton
              image={routeImage}
              color={'#1e1eff'}
              onPress={() => {
                close();
                addDestination();
              }}
            />
          </Pressable>
        )}
      </View>
    </DraggableSheet>
  );
}

const desktopStyles = StyleSheet.create({
  container: {
    overflowY: 'auto',
    flex: 1,
  },
  title: {
    fontSize: 30,
    fontWeight: 'bold',
    marginBottom: 10,
    paddingRight: 50,
  },
  childContainer: {
    flex: 1,
  },
  button: {
    alignSelf: 'flex-end',
    marginTop: 20,
  },
  imageContainer: {
    marginBottom: 20,
  },
});

const styles = StyleSheet.create({
  container: {
    overflowY: 'auto',
    flex: 1,
  },
  title: {
    fontSize: 25,
    fontWeight: 'bold',
    marginBottom: 10,
    paddingRight: 50,
  },
  childContainer: {
    flex: 1,
  },
  button: {
    position: 'absolute',
    right: 10,
  },
  imageContainer: {
    marginBottom: 10,
  },
});
